import {
  callApiGetAllLoaiVanBan,
  callApiGetDanhSachLoaiVanBan,
  callApiSuaLoaiSoVanBan,
  callApiTaoLoaiSoVanBan,
  callApiXoaLoaiSoVanBan,
  callApiGetDanhSachLoaiSoVanBanPaging,
  callApiGetDanhSachLoaiSoVanBan,
  callApiGetDanhSachSoVanBanPaging,
  callApiLoadOptionDonVi,
  callApiTaoSoVanBan,
  callApiSuaSoVanBan,
  callApiXoaSoVanBan,
  callApiGetDanhSachLoaiVanBanPaging,
  callApiTaoLoaiVanBan,
  callApiSuaLoaiVanBan,
  callApiGetChiTietLoaiVanBan,
  callApiXoaLoaiVanBan,
  callApiSaoChepVanBan,
  callApiGetDanhSachLoaiVanBanMacDinh,
  callApiThemTaiLieuVaoHoSoLuuTru,
  callApiGetDanhSachTaiLieuHoSo,
  callApiThemCongViecVaoHoSoLuuTru,
} from "@/api/van-ban";
import { ROUTE_NAME } from "@/constants/constants";
import router from "@/router";

const layChiTietVanBan = (context, payload) => {
  context.commit("LAY_CHI_TIET_VAN_BAN_THANH_CONG", payload.vanBanId);
};

const taoVanBan = (context, payload) => {
  context.commit("TAO_VAN_BAN_THANH_CONG", payload);
  context.commit("TANG_ID_VAN_BAN");
  router.push({
    path: ROUTE_NAME.VAN_BAN.NAME + ROUTE_NAME.VAN_BAN.DANH_SACH,
  });
};

const capNhatVanBan = (context, payload) => {
  context.commit("CAP_NHAT_VAN_BAN_THANH_CONG", payload);
};

const xoaVanBan = (context, payload) => {
  context.commit("XOA_VAN_BAN_THANH_CONG", payload);
};

const layDanhSachLoaiVanBan = () => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLoaiVanBan()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const layDanhSachLoaiVanBanMacDinh = (context) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLoaiVanBanMacDinh()
      .then((response) => {
        context.commit("SET_DANH_SACH_LOAI_VAN_BAN_MAC_DINH", response.data.Data)
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const themLoaiSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoLoaiSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaLoaiSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaLoaiSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaLoaiSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaLoaiSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLoaiSoVanBanPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLoaiSoVanBanPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_LOAI_SO_VAN_BAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLoaiSoVanBan = () => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLoaiSoVanBan()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachSoVanBanPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachSoVanBanPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_SO_VAN_BAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const loadOptionDonVi = () => {
  return new Promise((resolve, reject) => {
    callApiLoadOptionDonVi()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLoaiVanBanPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLoaiVanBanPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_LOAI_VAN_BAN_PAGING", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getChiTietLoaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetChiTietLoaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themLoaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoLoaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaLoaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaLoaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaLoaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaLoaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const saoChepVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSaoChepVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getAllLoaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAllLoaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachTaiLieuHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachTaiLieuHoSo(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};


const themTaiLieuVaoHoSoLuuTru = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemTaiLieuVaoHoSoLuuTru(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const themCongViecVaoHoSoLuuTru = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemCongViecVaoHoSoLuuTru(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};


export default {
  getAllLoaiVanBan,
  taoVanBan,
  capNhatVanBan,
  xoaVanBan,
  layChiTietVanBan,
  layDanhSachLoaiVanBan,
  themLoaiSo,
  suaLoaiSo,
  xoaLoaiSo,
  layDanhSachLoaiSoVanBanPaging,
  layDanhSachLoaiSoVanBan,
  layDanhSachSoVanBanPaging,
  suaSo,
  xoaSo,
  themSo,
  loadOptionDonVi,
  layDanhSachLoaiVanBanPaging,
  themLoaiVanBan,
  suaLoaiVanBan,
  xoaLoaiVanBan,
  layDanhSachLoaiVanBanMacDinh,
  getChiTietLoaiVanBan,
  saoChepVanBan,
  themTaiLieuVaoHoSoLuuTru,
  getDanhSachTaiLieuHoSo,
  themCongViecVaoHoSoLuuTru
};
